import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles, Layers, BookOpen, FileText, Users, Settings as SettingsIcon, ChevronRight } from "lucide-react";
import { useAuth } from "./AuthContext";
import { PageHeader, Card } from "./components/Field";

const QUICK_LINKS = [
  { to: "/admin/content/hero", label: "Edit Hero", desc: "Headline, lead, CTAs, image", icon: Sparkles },
  { to: "/admin/programs", label: "Programs", desc: "Add or update training programs", icon: Layers },
  { to: "/admin/content/coach", label: "Coach Mike", desc: "Bio, photo, credentials", icon: Users },
  { to: "/admin/content/book", label: "The Book", desc: "Cover, copy, Amazon link", icon: BookOpen },
  { to: "/admin/posts", label: "Posts", desc: "Blog, testimonials, clinics, more", icon: FileText },
  { to: "/admin/settings", label: "Site Settings", desc: "Logo, links, contact info", icon: SettingsIcon },
];

export const Dashboard = () => {
  const { user } = useAuth();
  return (
    <>
      <PageHeader
        overline="Welcome"
        title={`Hi${user?.name ? `, ${user.name.split(' ')[0]}` : ''}.`}
        description="Make live edits to the public site below. Every change saves to the database and reflects on the public site immediately on refresh."
        actions={
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="btn-primary !py-2.5 !px-5 !text-sm"
            data-testid="dashboard-view-site"
          >
            View Site <ArrowUpRight className="h-4 w-4" />
          </a>
        }
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {QUICK_LINKS.map((q) => {
          const Icon = q.icon;
          return (
            <Link
              key={q.to}
              to={q.to}
              className="bento-card p-5 group flex items-start gap-4 hover:border-brand transition-colors"
              data-testid={`dashboard-link-${q.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="h-10 w-10 grid place-items-center bg-brand/20 border border-brand/40 group-hover:bg-brand transition-colors shrink-0">
                <Icon className="h-5 w-5 text-brand-light group-hover:text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display uppercase tracking-tight text-lg">{q.label}</div>
                <div className="text-xs text-zinc-400 mt-1">{q.desc}</div>
              </div>
              <ChevronRight className="h-4 w-4 text-zinc-600 group-hover:text-brand-light shrink-0 mt-1" />
            </Link>
          );
        })}
      </div>

      <Card title="Tips" className="mt-10" description="">
        <ul className="text-sm text-zinc-400 space-y-2 list-disc list-inside">
          <li>Changes save instantly — you'll see "Unsaved changes" appear at the bottom while editing.</li>
          <li>Image uploads go straight to the site. Use the "Use URL" toggle to paste an external image instead.</li>
          <li>Programs can be reordered, marked as featured, or removed from the Programs page.</li>
          <li>Posts (blog, testimonials, clinics, gallery, video, FAQ, press) are managed under Posts. Public rendering for those types comes in the next phase.</li>
        </ul>
      </Card>
    </>
  );
};
